import { Colors, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

let animationFrameId = null;

export default class PopupButton extends Lightning.Component {
  countdownStopped = false; // Flag to indicate if the countdown has been stopped

  static _template() {
    return {
      w: 270,
      h: 57,
      rect: true,
      collision: true,
      ProgressBar: {
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 0,
        },
        color: Colors('#807F84').alpha(0.8).get(),
        w: 0,
        h: 50,
        x: 3.5,
        y: 3.5,
        zIndex: 1,
      },
      Title: {
        w: 270,
        h: 57,
        y: 15,
        color: Colors('#FFFFFF').get(),
        text: {
          fontSize: 23,
          textAlign: 'center',
          verticalAlign: 'middle',
          textColor: Colors('#ffffff').get(),
          shadow: true,
          shadowColor: Colors('#000000').get(),
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 1,
        },
        zIndex: 2,
      },
      Icon: {
        x: 220,
        zIndex: 2,
      },
    };
  }

  set button(val) {
    this._button = val;
  }

  set index(val) {
    this._index = val;
  }

  _stopCountDown() {
    this.countdownStopped = true; // Set the flag to stop the countdown
    cancelAnimationFrame(animationFrameId); // Stop the animation
    this._resetTitleText(); // Restore original text
  }

  _resetTitleText() {
    this.tag('Title').text = { text: this._button.title };
  }

  _enable() {
    this._updateTitle();
    this._updateIcon();
    this._updateTexture(this._button.unfocusBorderColor, this._button.buttonColor);
  }

  _focus() {
    this._updateTexture('#D6D6D7', this._button.focusColor);
  }

  _unfocus() {
    this._updateTexture(this._button.unfocusBorderColor, this._button.unfocusColor);
  }

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _updateTexture(borderColor, backgroundColor) {
    this.patch({
      texture: Lightning.Tools.getRoundRect(
        270,
        57,
        4,
        3,
        Colors(borderColor).alpha(1).get(),
        true,
        Colors(backgroundColor).get()
      ),
    });
  }

  _updateTitle() {
    this.tag('Title').patch({
      text: { text: this._button.title },
    });
  }

  _updateIcon() {
    this.tag('Icon').patch({
      y: (57 - this._button.icon.iconHeight) / 2,
      texture: Lightning.Tools.getSvgTexture(
        Utils.asset(this._button.icon.iconUrl),
        this._button.icon.iconWidth,
        this._button.icon.iconHeight
      ),
    });
  }

  _createCountDown() {
    const duration = 9000; // 9 seconds
    const progressBar = this.tag('ProgressBar');
    const startTime = Date.now();

    this._startCountDown(duration, progressBar, startTime);
  }

  _startCountDown(duration, progressBar, startTime) {
    this.patch({
      Title: undefined,
    });
    this.patch({
      Title: {
        x: 23,
        y: 15,
        color: Colors('#FFFFFF').get(),
        text: {
          text: `Up Next: ${Math.ceil(duration / 1000)}`,
          fontSize: 23,
          textAlign: 'center',
          verticalAlign: 'middle',
          textColor: Colors('#ffffff').get(),
          shadow: true,
          shadowColor: Colors('#000000').get(),
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 1,
        },
        zIndex: 2,
      },
    });
    const updateProgressBar = () => {
      if (this.countdownStopped) return; // Exit if countdown is stopped

      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      progressBar.w = progress * (270 - 7);

      const remainingSeconds = Math.ceil((duration - elapsed) / 1000);
      this.patch({
        Title: undefined,
      });
      this.patch({
        Title: {
          x: 23,
          y: 15,
          color: Colors('#FFFFFF').get(),
          text: {
            text: `Up Next: ${remainingSeconds}s`,
            fontSize: 23,
            textAlign: 'center',
            verticalAlign: 'middle',
            textColor: Colors('#ffffff').get(),
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 1,
          },
          zIndex: 2,
        },
      });
      if (progress < 1) {
        animationFrameId = requestAnimationFrame(updateProgressBar);
      } else {
        if (!this.countdownStopped) {
          this.fireAncestors('$PlayNextMovie');
        }
        this._resetTitleText();
      }
    };

    updateProgressBar();
  }

  _clearTimeout() {
    if (!this.countdownStopped) {
      this._stopCountDown();
    }
  }

  _handleEnter() {
    this._clearTimeout();

    switch (this._button.id) {
      case 1:
        this.fireAncestors('$PlayNextMovie');
        break;
      case 2:
        this.fireAncestors('$watchCredits');
        break;
    }
  }

  _getFocused() {
    return this;
  }
}
